import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    typography: {
        fontFamily: ['"Open sans"', "Arial", "sans-serif"].join(","),
    },
    palette: {
        primary: {
            main: "#363636",
        },
        error: {
            main: "#f9423a",
        },
        warning: {
            main: "#ffa53c",
        },
        action: {
            disabledBackground: "#d1d1d1",
            disabled: "white",
        },
    },
    components: {
        MuiButton: {
            defaultProps: {
                disableRipple: false,
            },
            styleOverrides: {
                root: {
                    fontSize: "1rem",
                    fontWeight: "bold",
                    lineHeight: 1.75,
                    padding: "10px 18px",
                    borderRadius: "10px",
                    "&.Mui-focusVisible": {
                        outline: "0",
                    },
                    "&.Mui-disabled": {
                        color: "#fff",
                    },
                    "&.Mui-disabled svg": {
                        color: "#fff",
                    },
                    "&.MuiButton-outlined": {
                        backgroundColor: "transparent",
                    },
                    "&:not(.MuiButton-text):hover": {
                        backgroundColor: "#000",
                        color: "#FFFFFF",
                    },
                    "&.MuiButton-text:hover": {
                        backgroundColor: "rgba(54, 54, 54, 0.08)",
                        color: "rgba(54, 54, 54, 1)",
                    },
                },
            },
        },
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
            styleOverrides: {
                root: {
                    fontFamily: ['"Open sans"', "Arial", "sans-serif"].join(","),
                    "&.Mui-focusVisible": {
                        outline: "-webkit-focus-ring-color auto 1px",
                    },
                    "&.Mui-disabled": {
                        color: "#d1d1d1",
                    },
                    "&.Mui-disabled svg": {
                        color: "#d1d1d1",
                    },
                },
            },
        },
        MuiSnackbar: {
            styleOverrides: {
                root: {
                    left: "auto",
                },
            },
        },
    },
});

export default theme;
